import { TotalAllocationEvent } from '../../event-types';
import { getTotalAllocatedMinutes } from '../../utils/common';
import { demandEventTemplate } from './demand-event-template';

export const totalAllocationTemplate = ({
  id,
  usersAllocatedMinutes,
  teamsAllocatedMinutes,
}: Pick<
  TotalAllocationEvent,
  'id' | 'roleId' | 'usersAllocatedMinutes' | 'teamsAllocatedMinutes'
>): string => {
  const totalAllocatedMinutes =
    getTotalAllocatedMinutes(usersAllocatedMinutes) +
    getTotalAllocatedMinutes(teamsAllocatedMinutes);

  return demandEventTemplate({ id, value: totalAllocatedMinutes });
};
